export default __webpack_public_path__ + "static/media/Seat.0c11e474.svg";